import { TextColor } from 'almanac-ui/icons'
import { ActiveColorsIndicator } from 'common/Prose/components/ActiveColorsIndicator/ActiveColorsIndicator'
import { TextColorPicker } from 'common/Prose/components/TextColorPicker/TextColorPicker'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import Styles from './InlineTextColorButton.module.scss'

export const InlineTextColorButton = observer(function InlineTextColorButton({ view }: { view: EditorView }) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const editorState = useContext(AlmanacEditorStateContext)!

  const activeColors = computed(() => Array.from(editorState.activeColors)).get()

  return (
    <DropdownTrigger autoFocus={false}>
      <InlineFormatButton
        data-testid="Text color"
        label="Text color"
        className={Styles.colorIconButton}
        frontIcon={() => (
          <>
            <TextColor />
            <ActiveColorsIndicator colors={activeColors} className={Styles.activeTextColorsOverride} />
          </>
        )}
      />
      {(closeDropdown) => {
        return <TextColorPicker view={view} activeColors={activeColors} callback={closeDropdown} />
      }}
    </DropdownTrigger>
  )
})
